import { orderBy } from 'lodash';
import badword from '~/utils/badword';
import * as types from './supporterType';

const INITIAL_STATE = {
  showLoading: false,
  showLoadingHistory: false,
  userDetail: null,
  patientList: [],
  supporterList: [],
  dataChat: [],
  images: [],
  dataSupporter: [],
  supporterFollowList: [],
  totalHistoryChat: 0,
  historyChatList: [],
  totalPatientChated: 0,
  patientChatedList: [],
  typing: null,
};

export default (state = INITIAL_STATE, action = {}) => {
  let patientChatedList;
  let historyChatList;
  let images;
  switch (action.type) {
    case types.SHOW_LOADING:
      return { ...state, showLoading: true };
    case types.HIDE_LOADING:
      return { ...state, showLoading: false };
    case types.SHOW_LOADING_HISTORY:
      return { ...state, showLoadingHistory: true };
    case types.HIDE_LOADING_HISTORY:
      return { ...state, showLoadingHistory: false };
    case types.GET_USER_DETAIL_SUCCESS:
      return {
        ...state,
        userDetail: action.userDetail,
        errorMessage: '',
      };
    case types.GET_USER_DETAIL_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case types.GET_PATIENT_SUCCESS:
      return {
        ...state,
        patientList: action.patientList,
        errorMessage: '',
      };
    case types.GET_PATIENT_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case types.GET_SUPPORTER_SUCCESS:
      return {
        ...state,
        supporterList: action.supporterList,
        errorMessage: '',
      };
    case types.GET_SUPPORTER_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case types.FOLLOW_SUPPORTER_SUCCESS:
      return {
        ...state,
        status: action.status,
        errorMessage: '',
      };
    case types.FOLLOW_SUPPORTER_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case types.GET_FOLLOW_SUPPORTER_SUCCESS:
      return {
        ...state,
        supporterFollowList: action.supporterFollowList,
        errorMessage: '',
      };
    case types.GET_FOLLOW_SUPPORTER_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case types.GET_HISTORY_CHAT_SUCCESS:
      historyChatList = orderBy(
        [...state.historyChatList, ...action.historyChatList],
        ['time'],
        ['asc'],
      );
      images = state.images;
      historyChatList.forEach(item => {
        if (item.content) item.content = badword.censorWords(item.content);
        if (item.file_url) {
          images.push({
            id: item.id,
            patientId: item.patient_id,
            supporterId: item.supporter_id,
            src: item.file_url,
          });
        }
      });
      // console.log(historyChatList)
      return {
        ...state,
        historyChatList,
        totalHistoryChat: action.totalHistoryChat,
        images,
        errorMessage: '',
        typing: null,
      };
    case types.GET_HISTORY_CHAT_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case types.GET_PATIENT_CHATED_SUCCESS:
      patientChatedList = orderBy(
        action.patientChatedList,
        ['data.time'],
        ['desc'],
      );
      patientChatedList.forEach(item => {
        if (item.data && item.data.content)
          item.data.content = badword.censorWords(item.data.content);
      });
      return {
        ...state,
        patientChatedList,
        totalPatientChated: action.totalPatientChated,
        errorMessage: '',
      };
    case types.GET_PATIENT_CHATED_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case types.SET_DATA_SUPPORTER:
      const { dataSupporter } = state;
      dataSupporter.push(action.dataSupporter);
      return { ...state, dataSupporter };
    case types.SET_FILTER:
      return { ...state, supporterList: action.listFilter };
    case types.SET_TYPING:
      return { ...state, typing: action.data };
    case types.SET_DATA_CHAT:
      // console.log(action.dataChat)
      const data = action.dataChat;
      if (data.action === 'message') {
        if (data.content) data.content = badword.censorWords(data.content);
        images = state.images;
        historyChatList = state.historyChatList;
        historyChatList.push(data);
        if (data.file_url) {
          images.push({
            id: data.id,
            patientId: data.patient_id,
            supporterId: data.supporter_id,
            src: data.file_url,
          });
        }
        return {
          ...state,
          historyChatList: historyChatList,
          images: images,
          typing: null,
        };
      } else return { ...state, typing: data };
    case types.SET_PATIENT_CHATED_LIST:
      patientChatedList = orderBy(
        action.patientChatedList,
        ['data.time'],
        ['desc'],
      );
      return {
        ...state,
        patientChatedList,
      };
    default:
      return state;
  }
};
